import { LandingButtonClickActionType, UserActionEnum } from '../../../types/customLogger';
import { onClickPageButtonTracking, usePageTracking } from '../../../hooks/pageTracking';
import { userAnalytics } from '../../../utils/analytics/userAnalytics';

const PAGE_NAME = 'lp_sleep_subscription_benefit';
const BUTTON_LABEL = '비밀혜택 받기';
const BENEFIT_DEEP_LINK = 'https://limh6.app.link/wu01vy7UX2b';

export default function LpSubscriptionBenefit() {
  usePageTracking(PAGE_NAME);

  const onClickBenefit = () => {
    onClickPageButtonTracking(PAGE_NAME, BUTTON_LABEL);
    const action = `${UserActionEnum.LANDING_BUTTON_CLICK}_${BUTTON_LABEL}` as LandingButtonClickActionType;
    userAnalytics(action, PAGE_NAME);
    window.location.href = BENEFIT_DEEP_LINK;
  };

  return (
    <div className="h-[100dvh] overflow-y-scroll overscroll-y-contain bg-[#101010] px-[clamp(16px,4.2vw,36px)] pb-[clamp(24px,6vw,64px)] pt-[clamp(28px,8vw,72px)] text-center text-white">
      <div className="mx-auto w-full max-w-[560px]">
        <div className="rounded-[16px] px-[clamp(12px,3.2vw,24px)] py-[clamp(20px,5.6vw,42px)]">
          <p className="whitespace-nowrap text-[clamp(24px,8.8vw,62px)] font-bold leading-[1.15] tracking-[-0.04em]">
            가입을 환영합니다!
          </p>
          <img
            src="/landing/sleep/lp-5835-hero-graphic.svg"
            alt="혜택 안내 그래픽"
            className="mx-auto mt-[clamp(20px,5vw,34px)] block w-[clamp(190px,48vw,290px)] max-w-full"
          />
        </div>

        <p className="whitespace-nowrap mt-[clamp(20px,5.2vw,36px)] text-[clamp(17px,5.2vw,52px)] font-semibold leading-[1.3] tracking-[-0.03em] text-white">
          이 링크에서 앱 다운로드 하면<br/> 비밀 혜택이 적용돼요.
        </p>

        <p className="whitespace-nowrap mt-[clamp(14px,4vw,26px)] text-[clamp(14px,4.6vw,34px)] font-semibold leading-[1.35] tracking-[-0.03em] text-[#FBB12C]">
          ※이 링크가 아닌 다른 곳에선 <br/> 혜택을 받을 수 없어요.
        </p>

        <button
          type="button"
          onClick={onClickBenefit}
          className="mx-auto mt-[clamp(24px,6vw,38px)] flex h-[clamp(60px,13vw,84px)] w-full max-w-[clamp(260px,72vw,420px)] items-center justify-center gap-[clamp(8px,2vw,14px)] rounded-full bg-[#4F68FC] px-[clamp(18px,5vw,30px)]"
        >
          <img
            src="/landing/sleep/lp-5835-download-icon.svg"
            alt=""
            aria-hidden
            className="h-[clamp(24px,5.8vw,34px)] w-[clamp(24px,5.8vw,34px)]"
          />
          <span className="whitespace-nowrap text-[clamp(20px,5.2vw,34px)] font-semibold leading-none tracking-[-0.03em] text-[#F4F6FF]">
            {BUTTON_LABEL}
          </span>
        </button>
      </div>
    </div>
  );
}
